import { render, staticRenderFns } from "./my-goods.vue?vue&type=template&id=3836c9d3&scoped=true&"
import script from "./my-goods.vue?vue&type=script&lang=js&"
export * from "./my-goods.vue?vue&type=script&lang=js&"
import style0 from "./my-goods.vue?vue&type=style&index=0&id=3836c9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3836c9d3",
  null
  
)

export default component.exports